export const tableHeader = [
  "name",
  "Positions",
  "createdAt",
  "updatedAt",
  "createdBy",
  "UpdatedBy",
];
